import { get } from 'svelte/store'
import { axiosInstance } from '@/plugins/axios'
import { hasCheckedDriverSalaryFiles, isDriverSalaryMenuVisible } from '@/components/appDriver/driverSalary/store'

async function fetchHasDriverSalaryFiles(): Promise<boolean> {
  try {
    const { data: response } = await axiosInstance.get(
      '/api/v1/driverSalaryFile/myDriverSalaryFiles?page=1&limit=1',
      { baseURL: import.meta.env.VITE_API_LOCA_URL },
    )

    return Boolean(response?.data?.length)
  } catch (error) {
    console.error('Cannot check driver salary files', error)
    return false
  }
}

// Home re-mounts every time the driver navigates back to it, so cache the
// eligibility result for the session instead of re-fetching on every visit.
export async function ensureDriverSalaryVisibilityChecked(): Promise<void> {
  if (get(hasCheckedDriverSalaryFiles)) return

  const hasFiles = await fetchHasDriverSalaryFiles()
  isDriverSalaryMenuVisible.set(hasFiles)
  hasCheckedDriverSalaryFiles.set(true)
}
